import { createPrefetchableAsyncDataContext } from '#src/app/shared/contexts/asyncData';

import { getMembershipAwarenessFormData } from './api';

/** @knip-ignore */
export const {
	Context: MembershipAwarenessFormDataContext,
	Provider: MembershipAwarenessFormDataContextProvider,
	useContext: useMembershipAwarenessFormData,
	useAsyncData: useMembershipAwarenessFormDataFromApi,
	prefetchAsyncData: prefetchMembershipAwarenessFormDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'MembershipAwarenessFormDataContext',
	dataProperty: 'formData',
	hasUserData: true,
	getData: getMembershipAwarenessFormData,
});
